<template>
    <div class="customer">
      <b-row class="header">
        <b-col cols="1">
          <a class="navbar-brand ml-3">
            <img @click="back()" src="../../../../assets/ic_cancel.png" class="y-icon-header">
          </a>
        </b-col>

        <b-col cols="9" style="margin: auto;">
          <div class="flex-grow-1 d-md-flex align-items-center justify-content-center d-none">
            <h1 class="h5 text-center title">Edit Customer</h1>
          </div>
        </b-col>

        <b-col cols="2" style="margin: auto;">
          <button @click="save()" class="button">Save</button>
        </b-col>
      </b-row>
        <section class="content h-100 w-100 d-flex justify-content-center align-items-center flex-column mb-5">
            <b-col cols="7" class="mx-auto">
                <div class="mt-5  d-none d-md-block">
                    <b-overlay :show="loading" rounded="sm">
                      <span class="font-weight-bold h5">Details</span>
                      <table class="table w-100 font-weight-bold table-bordered">
                            <tbody>
                              <tr>
                                  <th class="bg-light">First name</th>
                                  <td class="font-weight-normal">
                                      <b-form-input
                                              class="input"
                                              v-model="form.fname"
                                              type="text"
                                              placeholder="First Name"/>
                                  </td>
                              </tr>
                              <tr>
                                <th class="bg-light">Last name</th>
                                <td class="font-weight-normal">
                                  <b-form-input
                                      class="input"
                                      v-model="form.lname"
                                      type="text"
                                      placeholder="Last Name"/>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-light">Phone Number</th>
                                <td class="font-weight-normal">
                                  <b-form-input
                                      class="input"
                                      v-model="form.phone"
                                      type="phone"
                                      placeholder="Phone"/>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-light">Email Address</th>
                                <td class="font-weight-normal">
                                  <b-form-input
                                      class="input"
                                      v-model="form.email"
                                      type="email"
                                      placeholder="Email Address"/>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-light">Birthday</th>
                                <td class="font-weight-normal">
                                  <b-form-input
                                      class="input"
                                      v-model="form.date_of_birth"
                                      type="date"/>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-light">Address</th>
                                <td class="font-weight-normal">
                                  <b-form-input
                                      class="input"
                                      v-model="form.address"
                                      type="text"
                                      placeholder="Address"/>
                                </td>
                              </tr>
                            </tbody>
                      </table>

                    </b-overlay>
                </div>
            </b-col>
        </section>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "NewMember",
        data(){
          return{
            form:{
              fname:null,
              lname:null,
              phone:null,
              email:null,
              date_of_birth:null,
              address:null
            },
            id:null
          }
        },
        mounted() {
          var customer = JSON.parse(localStorage.getItem("customer"))
          this.id = customer.id
          this.form.fname = customer.name.split(" ")[0]
          this.form.lname = customer.name.split(" ")[1]
          this.form.phone = customer.phone_number
          this.form.email = customer.email
          this.form.date_of_birth = customer.date_of_birth
          this.form.address = customer.address
        },
        methods:{
            ...mapActions(["editCustomer"]),
          back(){
             window.history.back();
          },
          save(){
            this.loading = true
            let data = {
              id: this.id,
              name: this.form.fname +" "+ this.form.lname,
              phone_number: this.form.phone,
              email: this.form.email,
              date_of_birth: this.form.date_of_birth,
              address: this.form.address
            }
            this.loading = true
            this.editCustomer(data)
          },
        },
        computed:{
            ...mapGetters([
              "getCustomersSuccessResponse", "getCustomersErrorResponse"
            ]),
        },
        watch:{
          getCustomersSuccessResponse(){
            this.loading = false
            window.history.back()
          },
          getCustomersErrorResponse(data){
            this.loading = false
            alert(JSON.stringify(data))
          }
        }
    }
</script>

<style scoped>
    @import "../../../../commons/css/main.css";

    .customer{

    }

    .header{
        /*margin: 0;*/
        /*width: 100%;*/
        /*box-shadow: 0px 5px 3px #dedede;*/
        padding: 0;
        margin: 0;
        width: 100%;
        height: 85px;
        box-shadow: 0px 5px 3px #dedede;
    }

    .content{
        margin-top: 20px;
    }

    .y-icon-header{
        padding: 5px;
        width: 38px;
        height: 38px;
        margin: 16px 10px 10px 10px
    }

    .y-icon-header:hover{
        padding: 6px;
        background: #f3f3f3;
        border-radius: 6px;
    }

    .title{
        font-size: 22px;
        margin-top: 15px;
        font-weight: bold;
        margin-left: 10px;
    }

    .input{
        width: 100%;
        font-size: 16px;
        justify-content: left;
        text-align: left;
    }

    .active{
        background: #db0000;
        color: white;
        padding: 5px;
        border: 0;
        border-radius: 3px;
    }

    .button{
      width: 60%;
      background: #c82333;
      font-size: 14px;
      padding: 10px;
      color: white;
      border: solid 1px #c82333;
      border-radius: 3px;
    }

    .button:hover{
      background: #721c24;
    }

    .toggle-btn{
      font-size: 11px;
    }

    .toggle-piece{
      padding-top: 5px;
      padding-bottom: 5px;
      width: 100px;
      border: solid 1px #dedede;
    }

    .toggle-piece-active{
      color: #fff;
      padding-top: 5px;
      padding-bottom: 5px;
      width: 100px;
      background: #c82333;
      border: solid 1px #c82333;
    }

    .separate{
      margin-top: 40px;
    }

</style>